import { IHttpApi } from '@cian/http-api/shared';
import { IGetQuestionRequest, fetchGetQuestion, TGetQuestionResponse } from '../../repositories/quiz/v1/get-question';

export const getQuestions = async (httpApi: IHttpApi, parameters: IGetQuestionRequest) => {
  const response: TGetQuestionResponse = await fetchGetQuestion({ httpApi, parameters });
  if (response.statusCode === 200) {
    return response.response;
  } else {
    return null;
  }
};
